import { DataTableCellProps, TableCell } from 'components/dataTable';

export const UppercaseCell = ({ row, column }: DataTableCellProps) => {
  const value = row[column.id];
  return <TableCell data-column={column.id}>{value?.toString()?.toUpperCase() ?? '-'}</TableCell>;
};
